// Unpublished Work © 2021-2026 Deere & Company.

import React from 'react';
import {StyledEngineProvider} from '@mui/material/styles';
import {UserDataProvider} from '../../providers/user-data-provider';
import {UiIntlProvider} from '../../providers/ui-intl-provider';
import {ThemeProvider} from '../../providers/theme-provider';
import {CustomerRoutes} from './customer-routes';
import './customer-search-component.module.scss';
import {AccessCheck} from '../common/unauthorized-page-error/access-check';

export const CustomerSearchComponent = () => (
    <StyledEngineProvider injectFirst={true}>
        <UiIntlProvider>
            <ThemeProvider>
                <UserDataProvider>
                    <AccessCheck>
                        <CustomerRoutes/>
                    </AccessCheck>
                </UserDataProvider>
            </ThemeProvider>
        </UiIntlProvider>
    </StyledEngineProvider>
);
